import React from 'react';
interface SkillToolButtonProps {
  active: boolean;
  disabled?: boolean;
  onClick: () => void;
}

export default function SkillToolButton({ active, disabled, onClick }: SkillToolButtonProps) {
  const handleClick = () => {
    if (disabled) return;
    onClick();
  };
  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled}
      title="工具配置"
      style={{
        width: 28,
        height: 28,
        borderRadius: 8,
        border: 'none',
        background: active ? '#E6F0FF' : 'transparent',
        color: active ? '#1677ff' : '#8a94a6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        transition: 'all 0.15s'
      }}
      onMouseEnter={(e) => {
        if (!active && !disabled) {
          e.currentTarget.style.background = '#f2f3f5';
          e.currentTarget.style.color = '#4e5969';
        }
      }}
      onMouseLeave={(e) => {
        if (!active && !disabled) {
          e.currentTarget.style.background = 'transparent';
          e.currentTarget.style.color = '#8a94a6';
        }
      }}
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
          d="M10.5 1.8a3 3 0 0 0-3.7 3.7L1.8 10.5a1.4 1.4 0 0 0 2 2L8.8 7.5a3 3 0 0 0 3.7-3.7l-1.5 1.5-1.4-1.4z"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
    </button>
  );
}
